import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Auth } from '@feature/auth';
import { useResolve } from '@visiba/instantiation';
import { ReactNode } from 'react';
import styled from 'styled-components';

export function MyAccountUnauthorized() {
	const universalConfig = useResolve(UniversalConfig);
	const appName = universalConfig.appConfig?.storeCompanyName ?? universalConfig.appConfig?.displayName ?? null;

	return (
		<EmptyState>
			<Flex align='center' gap={tokens.size.x2}>
				<Flex gap={tokens.size.x1}>
					{appName != null ? (
						<Text variant='labelSemiBold' color={tokens.color.content.muted}>
							{appName}
						</Text>
					) : null}
					<Text.h2 variant='headingSmall'>{withTranslation('PW.Feature.MyAccount.UnauthorizedTitle')}</Text.h2>
					<Text.p variant='bodyRegular'>{withTranslation('PW.Feature.MyAccount.UnauthorizedDescription')}</Text.p>
				</Flex>
				<Auth.SignInButton />
			</Flex>
		</EmptyState>
	);
}

interface Props {
	children: ReactNode;
}

const elements = {
	container: styled.div`
		width: 100%;
		padding: ${tokens.spacing.x3} ${tokens.spacing.x2};
		color: ${tokens.color.content.muted};
		border: 1px dashed ${tokens.color.border.default};
		border-radius: 12px;

		h2 {
			font: ${tokens.text.heading.xSmall};
		}

		p {
			font: ${tokens.text.body.smallRegular};
		}

		${tokens.breakpointQuery.medium} {
			text-align: center;

			h2 {
				font: ${tokens.text.heading.small};
			}

			p {
				font: ${tokens.text.body.regular};
			}
		}
	`,
};

export function EmptyState({ children }: Props): JSX.Element {
	return <elements.container>{children}</elements.container>;
}
